export interface IDetailField {
  key: string;
  value: string | null;
  iconPath?: string;
  isCopyable?: boolean;
  copyableText?: string;
  isUrl?: boolean;
  isSnippet?: boolean;
}

export enum DetailFieldKey {
  Name = 'Name',
  Type = 'Type',
  AssociatedRisk = 'Associated Risk',
  AccessCount = 'Access Count',
  LastAccessed = 'Last Accessed',
  MSFTSensitivityLabel = 'MSFT Sensitivity Label',
  FileSnippet = 'File Snippet',
  URL = 'URL',
}
